import type { FaireThemeEntity } from "../../entity_types/theme";

export const post_service_impulse_gems: FaireThemeEntity = {
  token: "post-service-impulse-gems",
  type: "theme",
  name: "Post-Service Impulse Gems",
  description: "Perfect low-cost impulse buys for the front counter. These sparkling accessories are ideal for customers looking for a small treat after their beauty services.",
  teaser: "Operating as a Brick & Mortar beauty lounge, offering accessible jewelry price points at checkout can significantly boost average transaction value for clients completing their appointments.",
  detail: "Every item in the payload, from the $5.97 fringe earrings to the $7.59 vintage watch, features an accessible wholesale price point under $10, making them ideal for impulse retail.",
  bgColor: "#E8D4E8",
  tileBgColor: "#7a4a6b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_czd74qe6wf",
    "p_ez73rhp4bd",
    "p_bldn8hc8ry",
    "p_kw7qepc4xq",
    "p_pmjcj47u4x",
    "p_k8u4baa3p7",
    "p_3rhm5x538a",
    "p_8yyfkkmqnj",
    "p_zrj26hg9j2",
    "p_fbkjjdeybb",
    "p_f45zjqaa7k",
    "p_dv9gxysset",
    "p_m8ybpjvqmq",
    "p_kqhuhu575p",
    "p_uekhxy7gmg",
    "p_5fp6zhy54z",
    "p_3cjz3mgb3a",
    "p_wtgjnec5vr",
    "p_5gefr7p29d",
    "p_wkzqbgfyty",
    "p_d64ctr2yzr",
    "p_9pg2v6sxjz",
    "p_hr2c2qxn5f",
    "p_m2tpykvx8w",
    "p_kwj77tt9yp",
    "p_q868yjffpu",
    "p_baa3r8cuyx",
    "p_mh2wy6kvda",
    "p_zxurf3jtrh",
    "p_8dggs3n7xj",
    "p_w9wv6w63y6",
    "p_ut3tbs6mrw",
    "p_u23m575d56",
    "p_3y9tftjgbw",
    "p_7s6hhr5ypm",
    "p_rwuemcryd2",
    "p_yz5vsm6pbu",
    "p_6xvawh324h",
    "p_9de3mat7p2",
    "p_uxpdx9rb2w",
    "p_jhcrb92fnq",
    "p_3pcekmbkc4",
    "p_g8vwwymqtm",
    "p_2da2vev4bx",
    "p_h2psktut6k",
    "p_tpf2apke3k",
    "p_upnxt2sq6g",
    "p_jftm2z6968",
    "p_8sx4wk8ywe",
    "p_9vz3jy64qm",
    "p_8tj9kd673j",
    "p_hqbevzgdqf",
    "p_5gxv52hmma",
    "p_p3m5tesh4k",
    "p_ntae8aqm4v",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
